import { render, staticRenderFns } from "./Information2.vue?vue&type=template&id=2e96321a&scoped=true"
import script from "./Information2.vue?vue&type=script&lang=js"
export * from "./Information2.vue?vue&type=script&lang=js"
import style0 from "./Information2.vue?vue&type=style&index=0&id=2e96321a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e96321a",
  null
  
)

export default component.exports